import { reactive } from 'vue'

export function useEditInventoryDialog () {
  const state = reactive({
    isOpen: false,
    showLoader: false,
    formData: {},
    positiveButtonText: '',
    negativeButtonText: '',
    title: '',
    onConfirm: null,
    validationErrors: {}
  })

  const open = (config) => {
    const { formData, validationErrors, positiveButtonText, negativeButtonText, title, onConfirm } = config || {}
    state.formData = formData || {}
    state.validationErrors = validationErrors || {}
    state.positiveButtonText = positiveButtonText || ''
    state.negativeButtonText = negativeButtonText || ''
    state.title = title || ''
    state.onConfirm = onConfirm || null
    state.isOpen = true
  }

  const setLoader = (val) => {
    state.showLoader = val
  }

  const updateFormData = (data) => {
    state.formData = {
      ...state.formData,
      ...data
    }
  }

  const removeValidationError = (key) => {
    if (state.validationErrors?.[key]) {
      delete state.validationErrors[key]
    }
  }

  const setValidationErrors = (errors) => {
    state.validationErrors = errors
  }

  const close = () => {
    state.isOpen = false
    state.showLoader = false
    state.formData = {}
    state.positiveButtonText = ''
    state.negativeButtonText = ''
    state.title = ''
    state.onConfirm = null
    state.validationErrors = {}
  }

  return {
    state,
    open,
    close,
    setLoader,
    updateFormData,
    removeValidationError,
    setValidationErrors
  }
}
